import React from 'react';
import Logo from '../logo';

/** Renders the correct logo for the current color scheme without hydration flicker. */
const ThemeLogo = ({ height = '24px' }: { height?: string }) => (
  <>
    <span className="dark:hidden">
      <Logo color="dark" height={height} />
    </span>
    <span className="hidden dark:inline">
      <Logo color="light" height={height} />
    </span>
  </>
);

export default ThemeLogo;
